<div class="scaffold-event-button" style="text-align:right;position:relative;z-index:3">
  <p-button severity="link" variant="text" (click)="execute($event, item.operation)" [disabled]="checkDisable()">
    <span *ngIf="!item.use_icon">{{item.translation_key  ||item.label| translation|translationFromString | transformText :item?.text_transform}}</span>

    <span *ngIf="item.use_icon && !item.use_icon_with_text">
     <i [ngClass]="item.icon" [pTooltip]="item.translation_key  ||item.label| translation" [style.color]="item.color"></i>
    </span>

    <span *ngIf="item.use_icon && item.use_icon_with_text" style="display: inline-block;white-space: nowrap;">
      <i [ngClass]="item.icon" [style.color]="item.color"></i>
      <span  style="padding-left: 5px;">{{item.translation_key  ||item.label| translation|translationFromString | transformText :item?.text_transform}}</span>
     </span>
  </p-button>
</div>
